import React, {useEffect} from "react"
// import "./index.css"
import { BrowserRouter, Routes, Route } from "react-router-dom"
import App from "./App"
import Login from "./login.jsx"
import reportWebVitals from "./reportWebVitals"

let port
if (process.env.NODE_ENV === "development") {
  port = "https://protokol.kociuk.pl:3000"
} else {
  port = "https://protokol.kociuk.pl:3000"
}

export default function Main() {
  const [token, setToken] = React.useState(false)
  const [wynik, setWynik] = React.useState(null)
  const [user, setUser] = React.useState(null)

useEffect(() => {
  fetch(port + "/checkLoginPanel", {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => {
      if (response.status === 200) {
        return response.json()
      }
    })
    .then((data) => {
      if (data != null) {
        setUser(data)
        setToken(true)
      }
    })
    .catch((error) => {
      console.log(error)
    })
}, [])

  // <React.StrictMode>
  //get token from local storage
  //if token is not null then render App
  //else render Login
  React.useEffect(() => {
   setWynik( 
      <Routes>
        <Route path="/" element={token ? <App user={user} /> : <Login />} /> 
        {/* <Route
          path="home"
          element={token ? <App /> : <Navigate replace to="/" />}
        /> */}
      </Routes>
   )
  }, [token, user])

  return (
    <BrowserRouter>{wynik}</BrowserRouter>
  )
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
